export const GET_GROUP_REQUEST = 'GET_GROUP_REQUEST';
export const GET_GROUPS_REQUEST = 'GET_GROUPS_REQUEST';
export const GET_GROUP_BILLING_ENTITIES_REQUEST = 'GET_GROUP_BILLING_ENTITIES_REQUEST';
export const UPDATE_GROUP_REQUEST = 'UPDATE_GROUP_REQUEST';
export const CREATE_GROUP_REQUEST = 'CREATE_GROUP_REQUEST';
export const COMPLETE_GROUP_REQUEST = 'COMPLETE_GROUP_REQUEST';
export const DELETE_GROUP_REQUEST = 'DELETE_GROUP_REQUEST';
export const RESTORE_GROUP_REQUEST = 'RESTORE_GROUP_REQUEST';
export const ADD_PROJECT_TO_GROUP_REQUEST = 'ADD_PROJECT_TO_GROUP_REQUEST';
export const REMOVE_PROJECT_FROM_GROUP_REQUEST = 'REMOVE_PROJECT_FROM_GROUP_REQUEST';

export const getGroup = (groupId, callback) => ({
    type: GET_GROUP_REQUEST,
    payload: { groupId, callback }
});

export const getGroups = (start, limit, callback) => ({
    type: GET_GROUPS_REQUEST,
    payload: { start, limit, callback },
});

export const getGroupBillingEntities = (callback) => ({
    type: GET_GROUP_BILLING_ENTITIES_REQUEST,
    payload: { callback },
});

export const updateGroup = (groupId, groupData, callback) => ({
    type: UPDATE_GROUP_REQUEST,
    payload: { groupId, groupData, callback },
});

export const createGroup = (groupData, callback) => ({
    type: CREATE_GROUP_REQUEST,
    payload: { groupData, callback },
});

export const completeGroup = (groupId, options, callback) => ({
    type: COMPLETE_GROUP_REQUEST,
    payload: { groupId, options, callback },
});

export const deleteGroup = (groupId, callback) => ({
    type: DELETE_GROUP_REQUEST,
    payload: { groupId, callback },
});

export const restoreGroup = (groupId, callback) => ({
    type: RESTORE_GROUP_REQUEST,
    payload: { groupId, callback },
});

export const addProjectToGroup = (groupId, projectId, callback) => ({
    type: ADD_PROJECT_TO_GROUP_REQUEST,
    payload: { groupId, projectId, callback },
});

export const removeProjectFromGroup = (groupId, projectId, callback) => ({
    type: REMOVE_PROJECT_FROM_GROUP_REQUEST,
    payload: { groupId, projectId, callback },
});